import { exportUsers } from '../../api/users/exportUser';
import { downloadFileFromContent } from '../../helpers/redirects/downloadFileFromContent';
import createApiModule from '../createApiModule';
import { t } from '../../i18n';

const exportUserModule = createApiModule({
  name: 'exportUsers',
  apiMethod: exportUsers,
  onSuccess: (data) =>
    downloadFileFromContent(
      data.content,
      'users.csv',
      'text/csv;charset=utf-8;',
    ),
  onError: () => ({
    message: t('StoreUsersExportUserModuleErrorExportandoLosUsuariosAs'),
  }),
  onValidationError: () => ({
    message: t('StoreUsersExportUserModuleErrorExportandoLosUsuariosAs'),
  }),
});

export const {
  start: exportUser,
  success: exportUserOk,
  error: exportUserKo,
} = exportUserModule.slice.actions;

export default exportUserModule;
